module.exports = __webpack_public_path__ + "img/contacted.3eebe87e.svg";